<template>
  <div class="my_select_time">
    <el-select
      v-model="selectType"
      style="width:90px;margin-right:8px"
      @change="handleChange"
    >
      <el-option :value="1" label="昨天" v-if="yesterday"></el-option>
      <el-option :value="7" label="近7天"></el-option>
      <el-option :value="15" label="近15天"></el-option>
      <el-option :value="30" label="近30天"></el-option>
      <el-option :value="0" label="自定义"></el-option>
    </el-select>
    <time-pick
      style="flex:1"
      :type="type"
      :startTime="startTime"
      :endTime="endTime"
      :disabled="selectType != 0"
      @change="changeDate"
      :clearable="true"
      :defaultTimeStart="defaultTimeStart"
      :defaultTimeEnd="defaultTimeEnd"
    ></time-pick>
  </div>
</template>

<script>
/**入参
 * props:
 *  startTime
 *  endTime
 *  baseDate  相对于本日期的近几天，不设置至是从今天往前数，设置后是从设置值后往后数
 *  baseDateStart baseDateEnd 自定义值传值
 *  baseType 选择器外部传值 1 为自定义的昨天 -1是自定义值
 *
 * 事件
 * event：change(start,end)
 *
 */
import timePick from "./timePick.vue";
export default {
  name: "MyTimePicker",
  components: { timePick },
  props: {
    startTime: {
      default: "",
    },
    endTime: {
      default: "",
    },
    baseDate:{
      default: "",
    },
    baseDateStart:{
      default: "",
    },
    baseDateEnd:{
      default: "",
    },
    yesterday:{
      default: false,
    },
    baseType:{
      default: "7",
    },
    type: {
      default: "date",
    },
    defaultTimeStart: {
      default: "00:00:00",
    },
    defaultTimeEnd: {
      default: "23:59:59",
    },
  },
  data() {
    return {
      selectType: this.baseType == -1 ? 0 : this.baseType
    };
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    changeDate(time) {
      this.$emit("update:startTime", time.startTime);
      this.$emit("update:endTime", time.endTime);
    },
    handleChange(val) {
      if (val) {
        if(val !== -1){
          this.selectType = val;
          if(this.baseDate){
            console.log("baseDate: " + this.baseDate)
            let startTime = this.getRelativeTime(this.baseDate,0) + (this.type == 'datetime'?` ${this.defaultTimeStart}`:'');
            let endTime = this.getRelativeTime(this.baseDate,val) + (this.type == 'datetime'?` ${this.defaultTimeEnd}`:'');
            this.$emit("update:startTime", startTime);
            this.$emit("update:endTime", endTime);
          }else{
            let startTime = this.getLastTime(val) + (this.type == 'datetime'?` ${this.defaultTimeStart}`:'');
            let endTime = this.getLastTime(1) + (this.type == 'datetime'?` ${this.defaultTimeEnd}`:'');
            console.log("222",startTime,endTime);
            this.$emit("update:startTime", startTime);
            this.$emit("update:endTime", endTime);
          }
        }else{
          this.selectType = 0;
          let startTime = this.getRelativeTime(this.baseDateStart,0) + (this.type == 'datetime'?` ${this.defaultTimeStart}`:'');
          let endTime = this.getRelativeTime(this.baseDateEnd,0) + (this.type == 'datetime'?` ${this.defaultTimeEnd}`:'');
          this.$emit("update:startTime", startTime);
          this.$emit("update:endTime", endTime);
        }
        
      }
    },
    // 获取最近 last 天时间 格式 yyyy-mm-dd
    getLastTime(last) {
      let count = Number(last);
      const date = new Date(Date.now() - count * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      console.log("last", date, `${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    },

    // 获取相对于baseDate的时间
    getRelativeTime(baseDate,relative){
      let count = Number(relative);
      let now = new Date(baseDate);
      const date = new Date(now.getTime() + count * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      console.log("last", date, `${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.my_select_time {
  display: flex;
  width: 320px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: unset;
}
</style>
